import {

    RESET_MESSAGE,
    GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS,
    EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS,
    ADD_CYLINDER_TAG_MAPPING_FAILURE,
    ADD_CYLINDER_TAG_MAPPING_SUCCESS,
    ADD_CYLINDER_TAG_MAPPING_PROGRESS,
    GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS,
    GET_CYLINDER_TAG_MAPPING_LIST_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    CylinderTagMapping: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const cylinder_tag_mapping_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CYLINDER_TAG_MAPPING_LIST_SUCCESS:
            return { ...state, CylinderTagMapping: action.CylinderTagMapping, loading: false };
        case GET_CYLINDER_TAG_MAPPING_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CYLINDER_TAG_MAPPING_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CYLINDER_TAG_MAPPING_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_TAG_MAPPING_SUCCESS:
            return { ...state, CylinderTagMapping: [...state.CylinderTagMapping, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_TAG_MAPPING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CYLINDER_TAG_MAPPING_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CYLINDER_TAG_MAPPING_SUCCESS:
            return {
                ...state,
                CylinderTagMapping: state.CylinderTagMapping.map((CylinderTagMapping) =>
                    CylinderTagMapping.id === action.payload.id ? action.payload : CylinderTagMapping
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CYLINDER_TAG_MAPPING_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default cylinder_tag_mapping_reducer;